<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V14.584L9.70711 13.2929L9.6129 13.2097C9.22061 12.9047 8.65338 12.9324 8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071L11.2929 17.7071L11.3746 17.7803L11.4793 17.854L11.5768 17.9063L11.6879 17.9503L11.7993 17.9798L11.9248 17.9972L12 18L12.1181 17.9931L12.266 17.9642L12.3713 17.9288L12.4841 17.8753L12.5953 17.8037L12.6631 17.7485L12.7071 17.7071L15.7071 14.7071L15.7903 14.6129C16.0953 14.2206 16.0676 13.6534 15.7071 13.2929L15.6129 13.2097L15.5114 13.1404C15.1275 12.9116 14.6233 12.9625 14.2929 13.2929L13 14.586V7Z"
    fill="currentColor"
  />
</svg>
